import React, { useState, useEffect } from 'react';
import { footer, axisMaxLogo } from './../../images/images';
import './Footer.css';

export default function Footer() {

    const [channel, setChannel] = useState('')

    useEffect(() => {
        initializeChannelListener()
    }, [])

    const initializeChannelListener = () => {
        document.addEventListener('gotChannel', getChannel)
    }

    const getChannel = event => {
        let { channelName } = event.detail
        setChannel(channelName)
        document.removeEventListener('gotChannel', getChannel)
    }


    return (
        <>
            {/* {channel ? <div className="footerWrapper">
                {channel === 'BY' ? null :
                    <img src={axisMaxLogo} alt="Footer" className="footer_img" />}
            </div> : <></>} */}
        </>
    )
}